<template>
    <div>
      <h2>학원관리 앱</h2>
      <p>
        핸드폰의 학원관리앱을 이용하면, PC를 켜지 않고도 여러가지 관리를 할 수 있습니다.<br/>
        간단하고 빠르게 사용하기를 원한다면 학원관리 앱은 훌륭한 도구입니다.<br/>
      </p>
      
      <section>
        <div class="p-relative section_0" id="login">
            <div class="ft-b">1)  로그인</div>
        
            <div class="p-relative section_1">
                -   앱을 실행하고,<br/>
                    접속 url, 관리자 또는 강사의 ID, PW를 입력하여 로그인 합니다. 
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_login.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="main">
            <div class="ft-b">2)    메인 화면</div>
        
            <div class="p-relative section_2">
                전체 메뉴를 한 눈에 볼 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_main_screen.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="today">
            <div class="ft-b">3)    오늘 수업</div>
        
            <div class="p-relative section_2">
                오늘에 있는 수업을 보여줍니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_today.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="student">
            <div class="ft-b">4)    학생관리</div>
        
            <div class="p-relative section_1">
                -   학생 한 명에 대한 기본 정보를 생성, 수정할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_student.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="my_class">
            <div class="ft-b">5)    나의 수업</div>
        
            <div class="p-relative section_1">
                -   내가 수업하는 클래스에 대한 관리를 합니다.
            </div>
            <div class="p-relative section_1">
                -   즉, 출결, 보강, 과제, 시험, 수업후기 등의 작업을 합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_my_class.jpg" /></div>
            </div>

            <p></p>
            <div class="p-relative section_1 w160px" style="min-height:250px">
                -   “출결” 버튼을 클릭하면, 반의 학생의 출결상태를 볼 수 있으며, 수정할 수 있습니다.<br/>
                또한 출결메모를 기록할 수 있습니다. 
                <div class="p-absolute p-t0" style="left:120%" >
                    <img src="@/assets/aca/manual/app/app_teacher_my_class_student.jpg" />
                </div>
            </div>

            <p></p>
            <div class="p-relative section_1">
                -   과제/시험의 내용을 확인할 수 있습니다.<br/>
                또한 과제/시험의 결과를 평가하고 기록합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_my_class_homework.jpg" /></div>
            </div>

            <p></p>
            <div class="p-relative section_1">
                -   수업후기를 발송합니다..
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_my_class_message.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="message">
            <div class="ft-b">6)    메시지 관리</div>
        
            <div class="p-relative section_1">
                -   한 명의 메시지는 학생관리에서 보낼 수 있습니다.
            </div>
            <div class="p-relative section_1">
                -   여러명에게 메시지를 발송하기 위해서는 메시지 관리에서 대상학생을 선택후 발송합니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_message.jpg" /></div>
            </div>
            <div class="p-relative section_1">
                -   발송된 결과를 확인할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_message_result.jpg" /></div>
            </div>
        </div>

        <p></p>
        <div class="p-relative section_0" id="payment">
            <div class="ft-b">7)    수납 관리</div>
        
            <div class="p-relative section_1">
                -   월별 수납 상태를 확인할 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_payment.jpg" /></div>
            </div>

            <div class="p-relative section_1">
                -   미납자를 검색하고 미납문자를 보낼 수 있습니다.
            </div>
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/app/app_teacher_unpayment.jpg" /></div>
            </div>
        </div>
        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '로그인', link: '#login' },
                { label: '메인 화면', link: '#main' },
                { label: '오늘 수업', link: '#today' },
                { label: '학생 관리', link: '#student' },
                { label: '나의 수업', link: '#my_class' },
                { label: '메시지 관리', link: '#message' },
                { label: '수납 관리', link: '#payment' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


